var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11640_5700)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 21,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.25 38H54.375V36.2857C54.375 33.92 52.415 32 50 32C47.585 32 45.625 33.92 45.625 36.2857V38H44.75C43.7831 38 43 38.7671 43 39.7143V48.2857C43 49.2329 43.7831 50 44.75 50H55.25C56.2169 50 57 49.2329 57 48.2857V39.7143C57 38.7671 56.2169 38 55.25 38ZM50 33.6286C51.4963 33.6286 52.7125 34.82 52.7125 36.2857V38H47.2875V36.2857C47.2875 34.82 48.5038 33.6286 50 33.6286ZM55.25 48.2857H44.75V39.7143H55.25V48.2857ZM50 45.7143C50.9669 45.7143 51.75 44.9471 51.75 44C51.75 43.0529 50.9669 42.2857 50 42.2857C49.0331 42.2857 48.25 43.0529 48.25 44C48.25 44.9471 49.0331 45.7143 50 45.7143Z",
    fill: "#222222",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11640_5700",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11640_5700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11640_5700",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a86b28ce178826e7e7607c24e43b5d8a.svg";
export { ForwardRef as ReactComponent };